export const question = [
    {
      id: 1,
      title: "Do you have a partner?",
      yes: "E.g. married, engaged or living with a partner",
      no: " E.g. single, separated, divorced or widowed",
      name:'is_partner'
    },
    {
      id: 2,
      title: "Do you have children?",
      yes: "Not including step children",
      no: "",
      name:'is_children'
    },
    {
      id: 3,
      title: "Do you own your home?",
      yes: "Can be owned jointly and/or with a mortgage",
      no: "",
      name:'own_home'
    },
    {
      id: 4,
      title: "Do you live in Australia?",
      yes: "",
      no: "",
      name:'live_in_australia'
    },
    {
      id: 5,
      title: "Is everything you own in the Australia?",
      yes: "",
      no: "",
      name:'everything_you_own_in_australia'
    },
    {
      id: 6,
      title: "Do you have own business?",
      yes: "",
      no: "",
      name:'own_bussiness'
    },
    {
      id: 7,
      title: "Does your partner need a will?",
      yes: "Get Will for two people for $135",
      no: "just one will for myself for $90",
      name:'partner_need_will'
    },
  ];

export const serviceList = [
    {
        id:1,
        image:'/assets/images/doller-sign.jpeg',
        title:'Plan for your business',
        desc:'Set out what you want to happen to any business you own.'
    },
    {
        id:2,
        image:'/assets/images/list-2.png',
        title:'Protect your partner',
        desc:'Make sure they have the help they need if you’re not around.'
    },
    {
        id:3,
        image:'/assets/images/list-3.png',
        title:'Build a future for your kids',
        desc:'Appoint guardians if they’re under 18 and make sure no one misses out.'
    }
]
export const options = [
  { value: "Mr.", label: "Mr." },
  { value: "Mrs.", label: "Mrs." },
  { value: "Ms.", label: "Ms." },
  { value: "Miss.", label: "Miss." },
  { value: "Dr.", label: "Dr." },
  { value: "Mx.", label: "Mx." },
];

export const MerritalStatus = [
  { value: "1", label: "Single" },
  {
    value: "2",
    label: "With a partner, but not married",
  },
  {
    value: "3",
    label: "Registered civil partnership",
  },
  { value: "4", label: "Married" },
  { value: "5", label: "Married, but separated" },
  { value: "6", label: "Divorced" },
];

export const AssetsList = [
  { value: "1", label: "Bank Account" },
  {
    value: "2",
    label: "Pension",
  },
  {
    value: "3",
    label: "Property",
  },
  { value: "4", label: "Life insurances" },
  { value: "5", label: "Stock and Shares" },
  { value: "6", label: "Other" },
]